// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Scrollable from "../../../../../library/components/Scrollable.bs.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Button$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as WorkSpaceContext from "../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as PlaceOrderGaConfig from "../../../place-order/app/helper/PlaceOrderGaConfig.bs.js";
import * as Timestamp$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as TableComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";

function CustomerOrderTableCmp(Props) {
  var data = Props.data;
  var updateTable = Props.updateTable;
  var openPlaceOrderOpt = Props.openPlaceOrder;
  var selectedRebookCRNOpt = Props.selectedRebookCRN;
  var openPlaceOrder = openPlaceOrderOpt !== undefined ? openPlaceOrderOpt : (function (param) {
        
      });
  var selectedRebookCRN = selectedRebookCRNOpt !== undefined ? selectedRebookCRNOpt : "";
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  var tableColumnsSchema = function (param) {
    return {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Order ID"
              },
              accessor: (function (order) {
                  return {
                          TAG: /* ActionButton */3,
                          _0: Belt_Option.getWithDefault(order.order_id, "-"),
                          _1: (function (param) {
                              return Curry._2(workspaceDispatch.addTab, {
                                          TAG: /* OrderDetails */10,
                                          _0: Belt_Option.getWithDefault(order.order_id, "-"),
                                          _1: undefined
                                        }, false);
                            })
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Date"
                },
                accessor: (function (order) {
                    return {
                            TAG: /* Text */0,
                            _0: Timestamp$Catalyst.toString(order.order_date, "DD/MM/yyyy")
                          };
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Text */0,
                    _0: "Time"
                  },
                  accessor: (function (order) {
                      return {
                              TAG: /* Text */0,
                              _0: Timestamp$Catalyst.toString(order.order_time, "hh:mm A")
                            };
                    })
                },
                tl: {
                  hd: {
                    column: {
                      TAG: /* Text */0,
                      _0: "Status"
                    },
                    accessor: (function (order) {
                        return {
                                TAG: /* Text */0,
                                _0: order.status
                              };
                      })
                  },
                  tl: {
                    hd: {
                      column: {
                        TAG: /* Text */0,
                        _0: "Vehicle"
                      },
                      accessor: (function (order) {
                          return {
                                  TAG: /* Custom */5,
                                  _0: (function (param) {
                                      return React.createElement("div", {
                                                  className: "vehicle-details"
                                                }, React.createElement("p", undefined, order.vehicle.vehicle_type), React.createElement("p", undefined, order.vehicle.registration_number));
                                    })
                                };
                        })
                    },
                    tl: {
                      hd: {
                        column: {
                          TAG: /* Text */0,
                          _0: "Driver"
                        },
                        accessor: (function (order) {
                            return {
                                    TAG: /* Custom */5,
                                    _0: (function (param) {
                                        return React.createElement("div", {
                                                    className: "driver-details"
                                                  }, React.createElement("p", {
                                                        className: "name"
                                                      }, order.partner.name), React.createElement("p", undefined, order.partner.mobile));
                                      })
                                  };
                          })
                      },
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          };
  };
  var getTableColumnsSchema = function (param) {
    var table = tableColumnsSchema(undefined);
    if (country.TAG === /* India */1) {
      return table;
    }
    var obj_column = {
      TAG: /* Text */0,
      _0: ""
    };
    var obj_accessor = function (order) {
      return {
              TAG: /* Custom */5,
              _0: (function (param) {
                  if (Caml_obj.caml_equal(selectedRebookCRN, order.order_id)) {
                    return React.createElement(LoadingViewComponent$Catalyst.make, {});
                  }
                  var match = order.status.toLowerCase();
                  var tmp;
                  switch (match) {
                    case "cancelled" :
                    case "completed" :
                        tmp = false;
                        break;
                    default:
                      tmp = true;
                  }
                  return React.createElement(Button$Catalyst.make, {
                              text: "Rebook",
                              cb: (function (_event) {
                                  var id = order.order_id;
                                  if (id !== undefined) {
                                    PlaceOrderGaConfig.publishEvent({
                                          category: /* PlaceOrder */0,
                                          action: "Place Order Rebook Click Success",
                                          label: "1_" + id,
                                          value: undefined,
                                          nonInteraction: undefined
                                        }, country);
                                    return Curry._1(openPlaceOrder, id);
                                  }
                                  
                                }),
                              className: "btn-secondary disabled",
                              disabled: tmp
                            });
                })
            };
    };
    var obj = {
      column: obj_column,
      accessor: obj_accessor
    };
    return List.append(table, {
                hd: obj,
                tl: /* [] */0
              });
  };
  return React.createElement("div", {
              className: "table-container"
            }, React.createElement(Scrollable.make, {
                  height: "100%",
                  onScrollEndCallback: (function (param) {
                      return Curry._1(updateTable, String(data.last_date_timestamp));
                    }),
                  children: null
                }, React.createElement(TableComponent$Catalyst.make, {
                      columns: getTableColumnsSchema(undefined),
                      rowData: data.orders,
                      className: "c-nlo-table"
                    }), List.length(data.orders) < 1 ? React.createElement("div", {
                        className: "no-data"
                      }, "No Data Available") : null));
}

var make = CustomerOrderTableCmp;

export {
  make ,
  
}
/* react Not a pure module */
